import { useDropEvent, useUserCampaignData } from 'root/src/client/logic/dropEvent/hooks/useDropEvent';
import { useViewershipPlatformsByDares } from 'root/src/client/logic/dropEvent/hooks/useViewershipPlatformsByDares';
import { calculateMaxDaresByPlatform, } from 'root/src/shared/util/calculateMaxDares';
import { useUserCreatorData } from 'root/src/client/logic/auth/hooks/useUser';
import { isViewershipPlatform } from 'root/src/shared/platforms/guards/platform.guards';
export function useIsMaxDaresReachedByPlatforms(params = {}) {
    var _a;
    const { recordId, fallbackDrop } = params;
    const dropEvent = (_a = useDropEvent(recordId)) !== null && _a !== void 0 ? _a : fallbackDrop;
    const userCampaignData = useUserCampaignData(recordId);
    const { viewershipPlatformsByDares } = useViewershipPlatformsByDares(recordId, fallbackDrop);
    const { averageCcv = 0, averageYoutubeViews = 0, averageYoutubeShortsViews = 0, averageTikTokViews = 0 } = useUserCreatorData();
    if (!dropEvent) {
        return false;
    }
    if (!viewershipPlatformsByDares.length) {
        return false;
    }
    return viewershipPlatformsByDares.every((darePlatform) => {
        if (!isViewershipPlatform(darePlatform)) {
            return false;
        }
        const maxDares = calculateMaxDaresByPlatform({
            platform: darePlatform,
            campaign: dropEvent,
            averageYoutubeViews,
            averageYoutubeShortsViews,
            averageTikTokViews,
            averageCcv,
        });
        if (userCampaignData === null || userCampaignData === void 0 ? void 0 : userCampaignData.extraDares) {
            return false;
        }
        if (!maxDares) {
            return true;
        }
        return isMaxDaresReachedByPlatform({ dropEvent, maxDares, platform: darePlatform, userCampaignData });
    });
}
export function isMaxDaresReachedByPlatform({ maxDares, dropEvent, platform, userCampaignData }) {
    var _a, _b, _c;
    const { dares, creatorAcceptedDaresByPlatform } = dropEvent;
    const platformClassified = isViewershipPlatform(platform) ? platform : undefined;
    const userAcceptedDaresCount = platformClassified
        ? (_c = (_a = creatorAcceptedDaresByPlatform === null || creatorAcceptedDaresByPlatform === void 0 ? void 0 : creatorAcceptedDaresByPlatform[platformClassified]) !== null && _a !== void 0 ? _a : (_b = userCampaignData === null || userCampaignData === void 0 ? void 0 : userCampaignData.creatorAcceptedDaresByPlatform) === null || _b === void 0 ? void 0 : _b[platformClassified]) !== null && _c !== void 0 ? _c : 0
        : 0;
    const userMaxDares = Math.min(maxDares, dares.length);
    const isAnyDareAccepted = userAcceptedDaresCount > 0;
    return isAnyDareAccepted && (userMaxDares - userAcceptedDaresCount <= 0);
}
